<template>
    <div>
        <psi-page-title
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="pageBreadcrumbs"
        >
            <template #actions v-if="can('programs.create')">
                <program-options-menu></program-options-menu>
            </template>
        </psi-page-title>

        <!-- Content always starts with a v-card  -->
        <v-card class="mt-4">
            <v-card-text>
                <psi-toolbar
                    title="Programs"
                    :filters="[]"
                    :quicklinks="[]"
                    :actions="[]"
                    :showActionMenu="selectedItems.length > 0"
                    :view-option.sync="viewOption"
                    hide-view-options
                    @filter-item="filterItem"
                    @filter-clear-all="filterClearAll"
                    @quicklink-action="quicklinkAction"
                    @action="toolbarAction"
                    @refresh="refresh"
                    close-on-select
                    close-on-clear
                >
                </psi-toolbar>
                <keep-alive>
                    <component
                        :loading="loading"
                        :programs="programs"
                        :is="`program-${viewOption}`"
                        @item-selected="itemSelected"
                        @toggle-select-all="toggleSelectAll"
                        @action="programAction"
                    ></component>
                </keep-alive>
            </v-card-text>
        </v-card>
        <v-dialog v-model="graduateDialog" fullscreen persistent>
            <student-graduate
                :key="
                    Object.keys(selectedProgram).length > 0
                        ? selectedProgram.id
                        : $uuid.v4()
                "
                :program="selectedProgram"
                v-if="graduateDialog"
                @close="graduateDialog = false"
            ></student-graduate>
        </v-dialog>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import HomeLink from "@/mixins/homelink";

export default {
    name: "program-dashboard",
    mixins: [HomeLink],
    components: {
        ProgramList: () => import("@components/program/components/ProgramList"),
        ProgramOptionsMenu: () =>
            import("@components/program/components/ProgramOptionsMenu"),
        StudentGraduate: () =>
            import("@components/program/components/StudentGraduate.vue"),
    },
    data() {
        return {
            page: {
                title: "Rent Well Programs",
                icon: "mdi-view-dashboard-variant",
            },
            filters: [],
            quicklinks: [],
            selectedItems: [],
            graduateDialog: false,
            selectedProgram: {},
            viewOption: this.$vuetify.breakpoint.mobile ? "grid" : "list",
        };
    },
    computed: {
        ...mapGetters("Programs", ["programs", "loading"]),
        sessions() {
            return this.programs.length > 0;
        },
        pageBreadcrumbs() {
            return [
                Object.assign(
                    {
                        text: "Home",
                        disabled: false,
                    },
                    this.homeUrl
                ),
                {
                    text: "Programs",
                    disabled: true,
                    to: "#",
                },
            ];
        },
    },
    methods: {
        ...mapActions("Programs", ["getPrograms"]),
        filterApply() {
            this.getPrograms();
        },
        filterReset() {
            this.filters.forEach((item) => {
                this.filterUpdate(item.name, item.default, "value");
            });
        },
        filterItem(item) {
            this.filterUpdate(item.name, item.value, "value");
            this.filterApply();
        },
        filterClearAll() {
            this.filterReset();
            this.filterApply();
        },
        // update a filter item value on the filters data
        filterUpdate(filterName, data, key = "items") {
            const index = this.filters.findIndex(
                (item) => item.name == filterName
            );
            if (index !== -1) {
                let filter = this.filters[index];
                filter[key] = data;
                this.filters.splice(index, 1, filter);
            }
        },
        refresh() {
            this.filterApply();
        },

        toolbarAction(event) {
            switch (event.slug) {
                case "":
                    this.selectedItems = [];
                    break;
            }
        },
        quicklinkAction(event) {
            switch (event.title) {
                case "":
                    // Clear out any set filters
                    this.resetFilters();
                    // Add only this filter from the quicklink
                    // this.updateFilter("status", "Pending", "value");
                    // Get the result data
                    this.filterData();
                    break;
            }
        },
        itemSelected({ item, value }) {
            if (value) {
                // selected an item
                this.selectedItems.push(item);
            } else {
                // removed an item
                this.selectedItems.splice(
                    this.selectedItems.findIndex((elem) => elem.id === item.id),
                    1
                );
            }
        },
        toggleSelectAll({ items, value }) {
            if (value) {
                this.selectedItems = items;
            } else {
                this.selectedItems = [];
            }
        },
        programAction(id, item) {
            console.log("Action event with id = %s, action = %o", id, item);

            const params = {
                id,
            };
            let query = {};

            switch (item.name) {
                case "edit-program":
                    this.$router.push({ name: "Program Edit", params, query });
                    break;
                case "add-session":
                    query = {
                        scrollTo: "program-sessions",
                        addsession: true,
                    };
                    this.$router.push({ name: "Program Edit", params, query });
                    break;
                case "add-instructor":
                    query = {
                        scrollTo: "program-instructors",
                        addinstructors: true,
                    };
                    this.$router.push({ name: "Program Edit", params, query });
                    break;
                case "graduate-students":
                    this.selectedProgram = this.programs.find(
                        (item) => item.id === id
                    );
                    this.graduateDialog = true;
                    break;
            }
        },
    },
    mounted() {
        this.filterApply();
    },
};
</script>

<style scoped>
</style>